import { useState } from 'react'
import { useIntl } from 'react-intl'
import { mdiPlus } from '@mdi/js'

import TemplateUploadModal from './TemplateUploadModal'
import SuccessModal from 'components/Modal/SuccessModal'
import { commonMessages } from 'app/i18n/messages'
import { RegularModerate } from 'components/Typography'
import { templatesPageMessages } from 'features/templates/messages'
import {
  TemplateIcon,
  UploadTemplateDesktopButton,
  UploadTemplateMobileButton,
} from './styles'

function TemplateUploadButton() {
  const { formatMessage } = useIntl()
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isUploadSuccessModalOpen, setIsUploadSuccessModalOpen] =
    useState(false)
  const [uploadedFilename, setUploadedFilename] = useState('')
  return (
    <>
      <UploadTemplateDesktopButton
        type="button"
        variant="secondary"
        onClick={() => setIsUploadModalOpen(true)}
      >
        {formatMessage(templatesPageMessages.uploadTemplateButtonLabel)}
      </UploadTemplateDesktopButton>

      <UploadTemplateMobileButton onClick={() => setIsUploadModalOpen(true)}>
        <TemplateIcon path={mdiPlus} size={1} />
      </UploadTemplateMobileButton>

      {isUploadModalOpen && (
        <TemplateUploadModal
          isOpen
          setUploadedFilename={setUploadedFilename}
          onSuccess={() => setIsUploadSuccessModalOpen(true)}
          handleClose={() => setIsUploadModalOpen(false)}
        />
      )}

      {isUploadSuccessModalOpen && (
        <SuccessModal
          isOpen
          confirmBtnTitle={formatMessage(commonMessages.done)}
          title={formatMessage(commonMessages.success)}
          onConfirm={() => setIsUploadSuccessModalOpen(false)}
        >
          <RegularModerate>
            {formatMessage(templatesPageMessages.uploadedSuccessModalMessage, {
              uploadedFilename,
              b: (...chunks) => <b>{chunks}</b>,
            })}
          </RegularModerate>
        </SuccessModal>
      )}
    </>
  )
}

export default TemplateUploadButton
